module.exports = __webpack_public_path__ + "img/notificaciones.4960dcd5.svg";